import { Amplify } from 'aws-amplify';
import { store } from '../store';

const { 
    VITE_COGNITO_POOL_ID, 
    VITE_COGNITO_REGION, 
    VITE_COGNITO_APP_CLIENT, 
    VITE_COGNITO_IDENTITY_POOL_ID,
    MODE
} = import.meta.env

Amplify.configure({
    Auth: {
        identityPoolId: VITE_COGNITO_IDENTITY_POOL_ID,

        // REQUIRED - Amazon Cognito Region
        region: VITE_COGNITO_REGION,

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: VITE_COGNITO_POOL_ID,

        userPoolWebClientId: VITE_COGNITO_APP_CLIENT,

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false,
        
        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
        authenticationFlowType: 'USER_SRP_AUTH'

    }
});

// Analytics.autoTrack('pageView', {
//     // REQUIRED, turn on/off the auto tracking
//     enable: MODE === "production",
//     eventName: 'pageView',
//     attributes: async() => {
//         const state = store.getState()
//         const model = state?.site?.model
//         if(model?.orgFixed){
//             return {
//                 salesToken: model.organizations[0].attr?.token ?? "ISL",
//                 brand: model.organizations[0].name,
//                 email: window.localStorage.token ? JSON.parse(window.atob(window.localStorage.token.split('.')[1])).email : ''
//             }
//         }
//         return {
//             email: window.localStorage.token ? JSON.parse(window.atob(window.localStorage.token.split('.')[1])).email : ''
//         }
//     },
//     // OPTIONAL, by default is 'multiPageApp'
//     // you need to change it to 'SPA' if your app is a single-page app like React
//     type: 'SPA',
//     // OPTIONAL, the service provider, by default is the Amazon Pinpoint
//     provider: 'AWSPinpoint',
//     // OPTIONAL, to get the current page url
//     getUrl: () => {
//         // the default function
//         return window.location.origin + window.location.pathname;
//     }
// });

// Analytics.autoTrack('session', {
//     // REQUIRED, turn on/off the auto tracking
//     enable: MODE === "production",
//     // OPTIONAL, the service provider, by default is the Amazon Pinpoint
//     provider: 'AWSPinpoint'
// });

// Analytics.autoTrack('event', {
//     // REQUIRED, turn on/off the auto tracking
//     enable: MODE === "production",
//     // OPTIONAL, events you want to track, by default is 'click'
//     events: ['click'],
//     // OPTIONAL, the prefix of the selectors, by default is 'data-amplify-analytics-'
//     // in order to avoid collision with the user agent, according to https://www.w3schools.com/tags/att_global_data.asp
//     // always put 'data' as the first prefix
//     selectorPrefix: 'data-isl-analytics-',
//     // OPTIONAL, the service provider, by default is the Amazon Pinpoint
//     provider: 'AWSPinpoint'
// });